"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFilterParams = exports.SET_FILTER_PARAMS = exports.FILTER_PARAMS = void 0;
exports.FILTER_PARAMS = '[FilterParms]';
exports.SET_FILTER_PARAMS = `${exports.FILTER_PARAMS} SET`;
const setFilterParams = ({ filterParams }) => ({
    type: exports.SET_FILTER_PARAMS,
    payload: filterParams,
    meta: { feature: exports.FILTER_PARAMS },
});
exports.setFilterParams = setFilterParams;
//# sourceMappingURL=filterParams.js.map